<template>
    <v-select dense outlined v-bind="$attrs" :items="items" item-text="category" item-value="id" v-on="$listeners" />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CategorySelect',

    computed: {
        ...mapState('category', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            if (this.collection) {
                // no filter at the moment
                // return this.collection.models.filter((item) => !this.pageId || this.pageId === item.page_id);
                return this.collection.models;
            } else {
                return [];
            }
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('category', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
